module.exports = __webpack_public_path__ + "img/type10140.23f020eb.png";